/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var GetLicenseContactTypes = require('../services/GetLicenseContactTypes');
var GetConsumerDiscountBranchApplication = require('../services/GetCheckCasherBranchApplication');
var GetLicenseContactTypesByApplicationType = require('../services/GetLicenseContactTypesByApplicationType');
var GetLicenseContactsAndOfficersByEntity = require('../../common/services/GetLicenseContactsAndOfficersByEntity');
var GetApplicationDBAs = require('../services/GetApplicationDBAs');

var CheckCasherBranchLicenseApplication = require('../forms/CheckCasherBranchLicenseApplication');

module.exports = {
  event: 'build:license-new:check-casher-branch',

  channel: 'nd:application',

  builder: function(config) {
    var defer = $.Deferred();
    $.when(
      GetLicenseContactTypes(),
      GetConsumerDiscountBranchApplication(config.applicationId),
      GetLicenseContactTypesByApplicationType(config.applicationTypeId),
      GetLicenseContactsAndOfficersByEntity(config.entityId),
      GetApplicationDBAs(config.applicationId)
    ).done(function(licenseContactTypes, applicationContent, requiredLicenseContactTypes, existingContacts, dbas) {
      var checkCasherBranchApplicationView = new CheckCasherBranchLicenseApplication({
        isReadOnly: config.isReadOnly,
        mode: config.mode || 'new', // new, resubmit, print or int-expand
        model: new Backbone.Model({
          applicationId: config.applicationId,
          licenseContactTypes: licenseContactTypes,
          applicationContent: applicationContent,
          requiredLicenseContactTypes: requiredLicenseContactTypes,
          existingContacts: existingContacts,
          entityDBAs: dbas.entityDBAs,
          applicationDBAs: dbas.appDBAs
        })
      });
      defer.resolve(checkCasherBranchApplicationView);
    });
    return defer.promise();
  }
};
